// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"1671": "js-legacy","8626": "head-common","878": "stage_automation_icon","9474": "vendor",}[chunkId] || chunkId) + "-" + {"1671": "d847a8a44d3a0a5a","3353": "d8a6fcbe4a198eab","4276": "9f686a4e047e7d65","8476": "92aa827e5c9630a8","8626": "0bd48d483ed8eee2","878": "2b37b8f851f4734a","8944": "919e582cfe107b79","9384": "d6ff5d2a99bb7acc","9474": "53a3465d5a0f8045",}[chunkId] + ".js"
}